module.exports = __webpack_public_path__ + "25282d447acde158c9c922bb294b456e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/aboutus/one/one-bg.jpg
// module id = 1090
// module chunks = 0